export const getPhoneNumber = (state) => state.callMeBack.phoneNumber
export const getToken = (state) => state.callMeBack.token
export const getIdCampaign = (state) => state.callMeBack.idCampaign
export const getLead = (state) => state.callMeBack.lead
export const getIsSendLeadRequesting = (state) => state.callMeBack.isSendLeadRequesting
